import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "settings",
  "use": "settings-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"settings\"><path d=\"M14.001 8.784c.032-.256.056-.512.056-.784s-.024-.528-.056-.784l1.688-1.32a.404.404 0 00.096-.512l-1.6-2.768a.402.402 0 00-.488-.176l-1.992.8a5.845 5.845 0 00-1.352-.784l-.304-2.12A.39.39 0 009.657 0h-3.2a.39.39 0 00-.392.336l-.304 2.12c-.488.2-.936.472-1.352.784l-1.992-.8a.39.39 0 00-.488.176l-1.6 2.768a.394.394 0 00.096.512l1.688 1.32c-.032.256-.056.52-.056.784s.024.528.056.784l-1.688 1.32a.404.404 0 00-.096.512l1.6 2.768c.096.176.312.24.488.176l1.992-.8c.416.32.864.584 1.352.784l.304 2.12a.39.39 0 00.392.336h3.2a.39.39 0 00.392-.336l.304-2.12c.488-.2.936-.472 1.352-.784l1.992.8a.39.39 0 00.488-.176l1.6-2.768a.404.404 0 00-.096-.512l-1.688-1.32zM8.057 10.8c-1.544 0-2.8-1.256-2.8-2.8s1.256-2.8 2.8-2.8 2.8 1.256 2.8 2.8-1.256 2.8-2.8 2.8z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/settings.svg
// module id = Cic/
// module chunks = 39 44